import React from 'react';
import './styles.css';

export interface CardTitleProps {
  title: string;
  subtitle?: string;
  className?: string;
}

const CardTitle: React.FC<CardTitleProps> = ({
  title,
  subtitle,
  className = ''
}) => {
  return (
    <div className={`card-title ${className}`}>
      <h3>{title}</h3>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};

export default CardTitle; 